/* ============================================================
   Portante — scripts propios (vanilla JS)
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal on scroll (observer compartido) ---- */
  function initReveals() {
    var els = document.querySelectorAll(".rc-reveal");
    if (!els.length) return;
    document.documentElement.classList.add("rc-js");
    // red de seguridad: pase lo que pase, a los 3 s todo queda visible
    setTimeout(function () {
      document.querySelectorAll(".rc-reveal:not(.rc-visible)").forEach(function (el) {
        el.classList.add("rc-visible");
      });
    }, 3000);
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("rc-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("rc-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Count-up de cifras ---- */
  function initCounters() {
    var nums = document.querySelectorAll("[data-count]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-count"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute("data-count"));
        var decimals = (el.getAttribute("data-decimals") | 0);
        var dur = 1600, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString("es-ES");
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = decimals ? target.toFixed(decimals) : target.toLocaleString("es-ES");
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Carrusel de reseñas ---- */
  function initReviews() {
    document.querySelectorAll("[data-reviews]").forEach(function (root) {
      var track = root.querySelector(".rc-reviews__track");
      var prev = root.querySelector("[data-rev-prev]");
      var next = root.querySelector("[data-rev-next]");
      if (!track) return;
      var index = 0;
      function perView() { return window.innerWidth <= 600 ? 1 : (window.innerWidth <= 990 ? 2 : 3); }
      function maxIndex() { return Math.max(0, track.children.length - perView()); }
      function go() {
        index = Math.max(0, Math.min(index, maxIndex()));
        var card = track.children[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 22);
        var step = card.getBoundingClientRect().width + gap;
        track.style.transform = "translateX(" + (-step * index) + "px)";
      }
      if (next) next.addEventListener("click", function () { index++; go(); });
      if (prev) prev.addEventListener("click", function () { index--; go(); });
      window.addEventListener("resize", go);
      go();
    });
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    document.querySelectorAll(".rc-faq__item").forEach(function (item) {
      var q = item.querySelector(".rc-faq__q");
      var a = item.querySelector(".rc-faq__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.contains("rc-open");
        var parent = item.closest(".rc-faq");
        if (parent) parent.querySelectorAll(".rc-faq__item.rc-open").forEach(function (o) {
          if (o !== item) { o.classList.remove("rc-open"); var oa = o.querySelector(".rc-faq__a"); if (oa) oa.style.maxHeight = null; }
        });
        if (open) { item.classList.remove("rc-open"); a.style.maxHeight = null; }
        else { item.classList.add("rc-open"); a.style.maxHeight = a.scrollHeight + "px"; }
      });
    });
  }

  /* ---- Galería de producto (fotos y vídeo) ---- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (root) {
      var mainImg = root.querySelector("[data-gallery-main]");
      var video   = root.querySelector("[data-gallery-video]");
      var thumbs  = root.querySelectorAll("[data-gallery-thumb]");
      if (!mainImg || !thumbs.length) return;

      function mostrarImagen(url) {
        if (video) { try { video.pause(); } catch (e) {} video.hidden = true; video.removeAttribute("src"); }
        if (url) mainImg.src = url;
        mainImg.hidden = false;
      }
      function mostrarVideo(url, poster) {
        if (!video) return;
        mainImg.hidden = true;
        video.hidden = false;
        if (poster) video.setAttribute("poster", poster);
        if (video.getAttribute("src") !== url) video.setAttribute("src", url);
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
      }

      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          if (t.getAttribute("data-kind") === "video") {
            mostrarVideo(t.getAttribute("data-video"), t.getAttribute("data-poster"));
          } else {
            mostrarImagen(t.getAttribute("data-full"));
          }
          thumbs.forEach(function (x) { x.classList.remove("rc-active"); });
          t.classList.add("rc-active");
        });
      });

      // si la primera miniatura es el vídeo, deja la foto de portada visible y no autoarranques
      var first = thumbs[0];
      if (first && first.getAttribute("data-kind") === "video" && video) {
        video.setAttribute("poster", first.getAttribute("data-poster") || "");
      }
    });
  }

  /* ---- Selector de variantes del producto ---- */
  function initVariants() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var dataEl = form.querySelector("[data-variants-json]");
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('input[name="id"]');
      var priceNow = form.querySelector("[data-price-now]");
      var priceWas = form.querySelector("[data-price-was]");
      var addBtn = form.querySelector("[data-add-btn]");
      var addLabel = addBtn ? addBtn.getAttribute("data-label-add") : "";
      var soldLabel = addBtn ? addBtn.getAttribute("data-label-sold") : "";

      function money(cents) {
        return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
      }
      function selectedOptions() {
        var opts = [];
        form.querySelectorAll("[data-option-index]").forEach(function (group) {
          var checked = group.querySelector("input:checked");
          if (checked) opts[parseInt(group.getAttribute("data-option-index"), 10)] = checked.value;
        });
        return opts;
      }
      function update() {
        var sel = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceNow) priceNow.textContent = money(match.price);
        if (priceWas) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceWas.textContent = money(match.compare_at_price); priceWas.style.display = "";
          } else { priceWas.style.display = "none"; }
        }
        if (addBtn) {
          if (match.available) { addBtn.disabled = false; addBtn.textContent = addLabel; }
          else { addBtn.disabled = true; addBtn.textContent = soldLabel; }
        }
      }
      form.querySelectorAll("[data-option-index] input").forEach(function (inp) {
        inp.addEventListener("change", update);
      });
      update();
    });
  }

  /* ---- Parallax suave del hero ---- */
  function initParallax() {
    if (reduce) return;
    var layers = document.querySelectorAll("[data-parallax]");
    if (!layers.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        layers.forEach(function (l) {
          var speed = parseFloat(l.getAttribute("data-parallax")) || 0.1;
          l.style.transform = "translateY(" + (y * speed) + "px)";
        });
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function init() {
    initReveals();
    initCounters();
    initReviews();
    initFaq();
    initGallery();
    initVariants();
    initParallax();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* ---------- Comparador deslizante ---------- */
(function () {
  function initCompare() {
    document.querySelectorAll("[data-compare]").forEach(function (root) {
      var frame  = root.querySelector(".rc-comp__frame");
      var clip   = root.querySelector("[data-compare-clip]");
      var handle = root.querySelector("[data-compare-handle]");
      if (!frame || !clip || !handle) return;
      var dragging = false;

      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        clip.style.width = pct + "%";
        handle.style.left = pct + "%";
        handle.setAttribute("aria-valuenow", Math.round(pct));
      }
      function fromEvent(e) {
        var r = frame.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        set((x / r.width) * 100);
      }
      function start(e) { dragging = true; fromEvent(e); }
      function move(e)  { if (dragging) { fromEvent(e); if (e.cancelable) e.preventDefault(); } }
      function end()    { dragging = false; }

      frame.addEventListener("mousedown", start);
      frame.addEventListener("touchstart", start, { passive: true });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: false });
      window.addEventListener("mouseup", end);
      window.addEventListener("touchend", end);

      handle.addEventListener("keydown", function (e) {
        var now = parseFloat(handle.getAttribute("aria-valuenow")) || 50;
        if (e.key === "ArrowLeft")  { set(now - 4); e.preventDefault(); }
        if (e.key === "ArrowRight") { set(now + 4); e.preventDefault(); }
        if (e.key === "Home")       { set(0);  e.preventDefault(); }
        if (e.key === "End")        { set(100); e.preventDefault(); }
      });

      set(50);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initCompare);
  else initCompare();
  document.addEventListener("shopify:section:load", initCompare);
})();

/* ---------- Conmutador de colecciones ---------- */
(function () {
  function initColTabs() {
    document.querySelectorAll("[data-coltabs]").forEach(function (tabs) {
      var raiz = tabs.closest(".rc-cols");
      if (!raiz) return;
      var botones = tabs.querySelectorAll("[data-coltab]");
      var tarjetas = raiz.querySelectorAll(".rc-cols__card[data-group]");

      function mostrar(grupo) {
        tarjetas.forEach(function (c) { c.hidden = c.getAttribute("data-group") !== grupo; });
        botones.forEach(function (b) {
          var activo = b.getAttribute("data-coltab") === grupo;
          b.classList.toggle("rc-active", activo);
          b.setAttribute("aria-selected", activo ? "true" : "false");
        });
      }
      botones.forEach(function (b) {
        b.addEventListener("click", function () { mostrar(b.getAttribute("data-coltab")); });
      });
      mostrar("1");
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initColTabs);
  else initColTabs();
  document.addEventListener("shopify:section:load", initColTabs);
})();

/* ---------- Carrusel ---------- */
(function () {
  function initCarrusel() {
    document.querySelectorAll("[data-carrusel]").forEach(function (raiz) {
      var slides = raiz.querySelectorAll("[data-carr-slide]");
      if (slides.length < 2) return;
      var puntos = raiz.querySelectorAll("[data-carr-dot]");
      var i = 0, timer = null;
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var auto = raiz.getAttribute("data-autoplay") === "true" && !reduce;
      var espera = (parseInt(raiz.getAttribute("data-interval"), 10) || 6) * 1000;

      function ir(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle("rc-active", k === i); });
        puntos.forEach(function (p, k) {
          p.classList.toggle("rc-active", k === i);
          p.setAttribute("aria-selected", k === i ? "true" : "false");
        });
      }
      function arranca() { if (auto) { para(); timer = setInterval(function () { ir(i + 1); }, espera); } }
      function para() { if (timer) { clearInterval(timer); timer = null; } }

      var prev = raiz.querySelector("[data-carr-prev]");
      var next = raiz.querySelector("[data-carr-next]");
      if (prev) prev.addEventListener("click", function () { ir(i - 1); arranca(); });
      if (next) next.addEventListener("click", function () { ir(i + 1); arranca(); });
      puntos.forEach(function (p) {
        p.addEventListener("click", function () { ir(parseInt(p.getAttribute("data-carr-dot"), 10)); arranca(); });
      });
      raiz.addEventListener("mouseenter", para);
      raiz.addEventListener("mouseleave", arranca);
      document.addEventListener("visibilitychange", function () { document.hidden ? para() : arranca(); });

      // deslizar con el dedo
      var x0 = null;
      raiz.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; para(); }, { passive: true });
      raiz.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) ir(dx < 0 ? i + 1 : i - 1);
        x0 = null; arranca();
      });

      ir(0); arranca();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initCarrusel);
  else initCarrusel();
  document.addEventListener("shopify:section:load", initCarrusel);
})();
